export const toolbarTexts = {
  bold: 'Bold',
  fontFamily: 'Font',
  ai: 'AI text generation',
  fontSize: 'Font size',
  italic: 'Italic',
  underline: 'Underline',
  highlight: 'Highlight color',
  strikethrough: 'Strikethrough',
  color: 'Text color',
  search: 'Search',
  link: 'Link',
  image: 'Image',
  table: 'Insert table',
  tableActions: 'Table options',
  addRowBefore: 'Insert row above',
  addRowAfter: 'Insert row below',
  addColumnBefore: 'Insert column left',
  addColumnAfter: 'Insert column right',
  deleteRow: 'Delete row',
  deleteColumn: 'Delete column',
  deleteTable: 'Delete table',
  removeBorders: 'Remove borders',
  mergeCells: 'Merge cells',
  splitCell: 'Split cell',
  fixTables: 'Fix tables',
  textAlign: 'Alignment',
  bulletList: 'Bullet list',
  numberedList: 'Numbered list',
  indentLeft: 'Left indent',
  indentRight: 'Right indent',
  zoom: 'Zoom',
  undo: 'Undo',
  redo: 'Redo',
  trackChanges: 'Track Changes',
  trackChangesAccept: 'Accept changes under selection',
  trackChangesReject: 'Reject changes under selection',
  trackChangesOriginal: 'Toggle Show Original',
  trackChangesFinal: 'Toggle Show Final',
  clearFormatting: 'Clear formatting',
  copyFormat: 'Format painter',
  lineHeight: 'Line height',
  formatText: 'Format text',
  ruler: 'Show or hide ruler',
  pageBreak: 'Insert page break',
  documentEditingMode: 'Editing',
  documentSuggestingMode: 'Suggesting',
  documentViewingMode: 'Viewing',
  documentEditingModeDescription: 'Edit document directly',
  documentSuggestingModeDescription: 'Edits become suggestions',
  documentViewingModeDescription: 'View clean version of document only',
  linkedStyles: 'Linked styles',
};
